import {ExpiredCredit} from '../generated/types';

export function createExpiredCreditWithExpiredCredit({
  expired_at,
  expired_sum,
}: {
  expired_at: string;
  expired_sum: number;
}): ExpiredCredit {
  return {
    expiredAt: expired_at,
    expiredSum: expired_sum,
  };
}
